import * as React from 'react';
import Svg, { Path, G, Rect } from 'react-native-svg';

export default function TutoCircle({ size = 95 }: { size?: number }) {
  return (
    <Svg fill="none" height={size} viewBox="0 0 94 94" width={size}>
      <G>
        <Rect
          fill="#F7E9AB"
          height="80"
          rx="40"
          shape-rendering="crispEdges"
          width="80"
          transform={[{ translateX: 6.77344 }, { translateY: 0.494141 }]}
        />
        <Path
          d="M43.04 23.99C44.17 23.34 45.46 23 46.77 23C48.08 23 49.37 23.34 50.51 23.99L68.65 34.41C68.84 34.52 68.99 34.68 69.11 34.87C69.22 35.06 69.27 35.27 69.27 35.49C69.27 35.71 69.22 35.93 69.11 36.12C68.99 36.31 68.84 36.47 68.65 36.58L61.77 40.52V51.74C61.77 51.91 61.74 52.07 61.68 52.22C61.62 52.37 61.52 52.51 61.41 52.63L61.4 52.63L61.4 52.64L61.38 52.65L61.32 52.71L61.12 52.89C60.95 53.05 60.7 53.26 60.37 53.51C59.47 54.2 58.52 54.82 57.52 55.35C54.21 57.1 50.52 58.01 46.77 57.99C43.03 58.01 39.34 57.1 36.03 55.34C35.03 54.81 34.08 54.2 33.18 53.51C32.85 53.26 32.53 52.99 32.22 52.71C32.09 52.59 31.98 52.44 31.9 52.27C31.82 52.11 31.78 51.93 31.77 51.74V40.52L26.77 37.65V49.24C26.77 49.57 26.64 49.89 26.41 50.13C26.17 50.36 25.86 50.49 25.52 50.49C25.19 50.49 24.87 50.36 24.64 50.13C24.41 49.89 24.27 49.57 24.27 49.24V35.49C24.27 35.27 24.33 35.05 24.45 34.86C24.56 34.66 24.73 34.5 24.92 34.4L43.04 23.99ZM50.51 46.99C49.37 47.64 48.08 47.99 46.77 47.99C45.46 47.99 44.17 47.64 43.04 46.99L34.27 41.96V51.18C35.18 51.93 36.17 52.59 37.21 53.14C39.41 54.31 42.64 55.49 46.77 55.49C50.11 55.51 53.39 54.7 56.34 53.14C57.38 52.59 58.36 51.93 59.27 51.18V41.95L50.51 46.99ZM49.26 26.16C48.51 25.73 47.65 25.5 46.77 25.5C45.9 25.5 45.04 25.73 44.28 26.16L28.03 35.49L44.28 44.82C45.04 45.26 45.9 45.49 46.77 45.49C47.65 45.49 48.51 45.26 49.26 44.82L65.51 35.49L49.26 26.16Z"
          fill="#CC7481"
        />
      </G>
    </Svg>
  );
}
